import { FC, useState } from 'react';
import FilterAndPaginate from '../common/FilterAndPaginate';
import { Table } from 'semantic-ui-react';
import SortableHeaderCell from '../common/SortableHeaderCell';
import Pagination from '../common/Pagination';
import ConfirmWrapper from '../common/ConfirmWrapper';
import { PartyProduct } from '../../types';
import { Link } from 'react-router-dom';
import FeatureFlag from '../common/FeatureFlag';
import { Label, Popup, Button } from 'semantic-ui-react';
import PartyApi from '../../api/partyApi';
import toastr from 'toastr';

const ProductDistributorsTable: FC<any> = ({
    paginatedItems,
    handleSortChange,
    handleAddFilter,
    handlePaginationChange,
    paginationOptions,
    uiActions,
    confirmPopupActions,
    fetchLookUpValuesById,
    ...rest
}) => {
    const [isLoading, setIsLoading] = useState(false);

    //Call the Notification API to send a notification to the distributor
    const handleSendNotification = async (
        targetPartyId: string | undefined,
        ownerPartyId: string | undefined,
        productLabel: string,
    ) => {
        setIsLoading(true);

        console.log('targetPartyId', targetPartyId);
        console.log('ownerPartyId', ownerPartyId);
        console.log('productLabel', productLabel);

        if (!targetPartyId || !ownerPartyId || !productLabel) {
            toastr.error('An Error occurred while sending the notification');
            setIsLoading(false);
            return;
        }

        try {
            //This needs an Owner Party
            //Target Id
            //Product Label
            const result = await PartyApi.sendNotification({
                notificationType: 'INCOMPLETE_PRODUCT_SUBMISSION',
                targetPartyId,
                productLabel,
                ownerPartyId,
                middlePartyId: ownerPartyId, //Owner gets overridden so template uses this
            });

            console.log('result', result);

            toastr.success('Notification sent');
        } catch (e: any) {
            toastr.error(e);
        }
        setIsLoading(false);
    };
    return (
        <>
            <Table celled sortable>
                <Table.Header>
                    <Table.Row>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="party.label"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            isSearchable={true}
                            isFilterable={false}
                        >
                            Name
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="executionTicketSetlabel"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            isSearchable={true}
                            isFilterable={false}
                        >
                            Product Name
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="ownerParty.label"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            isSearchable={true}
                            isFilterable={false}
                        >
                            Source
                        </SortableHeaderCell>
                        <FeatureFlag
                            featureFlag="Client1Specific"
                            showHide={true}
                        >
                            <SortableHeaderCell
                                {...paginationOptions}
                                name="commissionPercentage"
                                handleSortChange={handleSortChange}
                                isSearchable={false}
                                isFilterable={false}
                            >
                                Commission
                            </SortableHeaderCell>
                            <SortableHeaderCell
                                {...paginationOptions}
                                name="feeAmount"
                                handleSortChange={handleSortChange}
                                isSearchable={false}
                                isFilterable={false}
                            >
                                Fee
                            </SortableHeaderCell>
                        </FeatureFlag>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="clientStatusLabel"
                            //handleSortChange={handleSortChange}
                            //handleAddFilter={handleAddFilter}
                            isSearchable={false}
                            isFilterable={false}
                        >
                            Status
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="lookUpValueCode"
                            width={1}
                        >
                            &nbsp;
                        </SortableHeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {paginatedItems.map((item: PartyProduct, index) => (
                        <Table.Row key={index}>
                            <Table.Cell>
                                <Link to={item.clientLinkPath}>
                                    {item?.party?.label}
                                </Link>
                            </Table.Cell>
                            <Table.Cell>
                                <Link to={item.clientLinkPath}>
                                    {item.executionTicketSetlabel}
                                </Link>
                            </Table.Cell>
                            <Table.Cell>{item?.ownerParty?.label}</Table.Cell>
                            <FeatureFlag
                                featureFlag="Client1Specific"
                                showHide={true}
                            >
                                <Table.Cell>
                                    {item.commissionPercentage
                                        ? `${Number(item.commissionPercentage).toFixed(2)}%`
                                        : ''}
                                </Table.Cell>
                                <Table.Cell>
                                    {item.feeAmount
                                        ? `${Number(item.feeAmount).toFixed(2)}`
                                        : ''}
                                </Table.Cell>
                            </FeatureFlag>
                            <Table.Cell>
                                <Label color={item?.clientStatusColor}>
                                    {item?.clientStatusLabel}
                                </Label>
                            </Table.Cell>
                            <Table.Cell collapsing>
                                {(item?.clientStatusColor === 'orange' ||
                                    item?.clientStatusColor === 'grey') && (
                                    <Popup
                                        content="Send Reminder"
                                        trigger={
                                            <Button
                                                basic
                                                loading={isLoading}
                                                icon="mail"
                                                onClick={() =>
                                                    handleSendNotification(
                                                        item?.partyId,
                                                        item?.executionOwnerPartyId,
                                                        item.executionTicketSetlabel,
                                                    )
                                                }
                                                color="blue"
                                                compact
                                            />
                                        }
                                    />
                                )}
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
            <Pagination
                activePage={paginationOptions.activePage}
                onPageChange={handlePaginationChange}
                totalPages={paginationOptions.totalPages}
            />
        </>
    );
};

function mapOptions(props) {
    return {
        items: props.distributors || [],
    };
}

export default FilterAndPaginate(mapOptions)(
    ConfirmWrapper(ProductDistributorsTable),
);
